import { useEffect, useState } from "react"

import { distinctBy } from "web/services/helpers"

import { getMapBoxSafeValues } from "./common"

import LocationMap from "./LocationMap"
import DealAssetLocationCard from "./LocationCard/DealAssetLocationCard"

export default function DealAssetMap({
  dealAssets,
  onSelectionChanged,
  isLoading,
  showOrdinals,
}) {
  const [locationInFocus, setLocationInFocus] = useState()
  const hasLocationInFocus = !!locationInFocus

  const dealAssetLocations = dealAssets.map((dealAsset) => {
    const dealAssetValues = getMapBoxSafeValues(dealAsset.values)
    return {
      ...dealAsset.locations[0],
      values: dealAssetValues,
    }
  })

  const distinctAssetLocations = distinctBy(dealAssetLocations, "id")

  const locationInFocusWithSubjects = { location: locationInFocus }

  if (hasLocationInFocus) {
    const dealAssetsAtLocation = dealAssets.filter((a) =>
      a.locations.some((l) => l.id === locationInFocus.id)
    )

    const dealIdsAtLocation = dealAssetsAtLocation
      .map((a) => a.account_deals)
      .flat()
      .map((ad) => ad.deal_id)

    locationInFocusWithSubjects.dealAssets = dealAssetsAtLocation
    locationInFocusWithSubjects.dealIds = dealIdsAtLocation
  }

  const primarySubject =
    hasLocationInFocus && locationInFocusWithSubjects.dealAssets[0]

  const hasPrimarySubject = !!primarySubject

  // deal asset in focus may have been removed between
  // renders by change in filter conditions
  useEffect(() => {
    if (hasLocationInFocus && !hasPrimarySubject) {
      setLocationInFocus(undefined)
    }
  }, [hasLocationInFocus, hasPrimarySubject])

  const selected = dealAssets.filter((el) => el.selected)

  return (
    <LocationMap
      subjectType="deal_asset"
      subjects={dealAssets}
      primarySubject={primarySubject}
      selected={selected}
      locations={distinctAssetLocations}
      locationInFocus={locationInFocusWithSubjects}
      onLocationClick={setLocationInFocus}
      onSelectionChanged={onSelectionChanged}
      detailCard={DealAssetLocationCard}
      isLoading={isLoading}
      showOrdinals={showOrdinals}
    />
  )
}
